import React, { HTMLAttributes } from 'react'
import { Color } from '~theme'
import { Icon, IconName } from '~components/Icon'
import * as Styled from './Loader.styles'
import { LoaderColor, LoaderSize } from './Loader.types'
import { LOADER_SIZE_LIST } from './Loader.consts'

function getSize(size: LoaderSize) {
  if (typeof size === 'number') {
    return size
  }

  return LOADER_SIZE_LIST[size]
}

interface CustomProps {
  /**
   * How large should the loader be?
   */
  size?: 'small' | 'medium' | 'large' | number
  /**
   * What color should the loader has?
   */
  color?: LoaderColor
}

export type ComponentProps = CustomProps & HTMLAttributes<HTMLDivElement>

const Loader: React.FC<ComponentProps> = ({ size = 'small', color = Color.primary, ...divProps }) => (
  <Styled.Container size={getSize(size)} color={color} {...divProps}>
    <Icon name={IconName.spinner} />
  </Styled.Container>
)

export default Loader
